import draggable from "vuedraggable";

export default {
  name: "NewsContentTypes",
  components: {
    draggable
  },
  props: [
    "type",
    "additionalName",
    "images",
    "title",
    "showGallery",
    "selectedImages",
    "isFirst",
    "isLast",
    "id",
    "principalEdit"
  ],
  data: () => ({
    extended: false
  }),
  computed: {
    localSelectedImages: {
      get() {
        return this.images;
      },
      set(images) {
        this.$emit("updateImages", { images, id: this.id });
        this.$forceUpdate();
      }
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    },
    show() {
      if (this.isAdmin) {
        return true;
      }
      return this.type !== "html";
    }
  },
  methods: {
    edit() {
      this.extended = !this.extended;
      this.$forceUpdate();
    },
    getIconPath() {
      switch (this.type) {
        case "title":
          return require("@/assets/TitleIcon.svg");
        case "date":
          return require("@/assets/DateIcon.svg");
        case "text1":
          return require("@/assets/TextIcon.svg");
        case "text2":
          return require("@/assets/TextIcon.svg");
        case "text3":
          return require("@/assets/TextIcon.svg");
        case "images1":
          return require("@/assets/ImageIcon.svg");
        case "images2":
          return require("@/assets/ImageIcon.svg");
        case "images3":
          return require("@/assets/ImageIcon.svg");
        case "images4":
          return require("@/assets/ImageIcon.svg");
        case "files":
          return require("@/assets/FileIcon.svg");
        case "video":
          return require("@/assets/VideoIcon.svg");
        case "html":
          return require("@/assets/CodeIcon.svg");
        case "social":
          return require("@/assets/SocialIcon.svg");
        default:
          return "";
      }
    }
  }
};
